import cstaKtDefs from '@/util/call/kt/ktAPI/cstaKtDefs';
import klcnsAgtStaDefs from '@/util/call/klcns/klcnsAPI/klcnsAgtStaDefs';
import cstaDefs from '@/util/call/neomecca/netDialAPI/cstaDefs';
import neoWebRtcDefs from '@/util/call/neoWebRTC/neoWebRtcAPI/cstaDefs';
import util from '@/util';
import apiEvent from '@/util/call/apiEvent';
import { store } from '@/store/store';

const isKT = () => util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('KT') > -1;
const isKLCNS = () => util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('KLCNS') > -1;
const isNeomecca = () =>
  util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('NEOMECCA') > -1;
const isNeoWebRtc = () =>
  util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('NEO_WEB_RTC') > -1;

const getCallDefs = () => {
  if (isKT()) {
    return cstaKtDefs;
  } else if (isKLCNS()) {
    return klcnsAgtStaDefs;
  } else if (isNeoWebRtc()) {
    return neoWebRtcDefs;
  } else {
    return cstaDefs;
  }
};

const callDefs = getCallDefs();

const getCallAgentId = () => {
  // klcns일 때에는 내선번호를, 타 채널일 때에는 callAgentId를 리턴한다.
  if (isKLCNS()) {
    return store.getters.telNumber;
  } else if (isNeomecca() || isNeoWebRtc()) {
    return store.getters.callLoginId;
  }
};

export { callDefs, apiEvent, getCallAgentId };



// WEBPACK FOOTER //
// ./src/util/call/index.js